import React from 'react';
import { COLORS, Color } from '../../../styles/variables';

interface SpyderDefaultIconProps {
  color?: Color;
}

const SpyderDefaultIcon: React.FC<SpyderDefaultIconProps> = ({ color = COLORS.black }) => (
  <svg width="76" height="38" viewBox="0 0 76 38" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_816_45062)">
      <path
        d="M66.9299 29.77L70.2599 28.49C70.8374 27.5928 71.1622 26.5563 71.2 25.49C71.193 25.185 71.1031 24.8877 70.9399 24.63L70 24.29V21.56C69.8279 20.8962 69.5063 20.2805 69.0599 19.76V18.57C69.0599 18.57 62.4899 16.52 51.2999 16.52C49.7833 16.6825 48.2903 17.0181 46.85 17.52C46.77 17.52 46.6799 17.35 46.6799 17.18C46.6799 17.01 46.5999 16.75 46.5099 16.5C46.488 16.3442 46.4352 16.1945 46.3546 16.0594C46.274 15.9244 46.1672 15.8068 46.0405 15.7137C45.9138 15.6205 45.7698 15.5536 45.6168 15.5169C45.4639 15.4802 45.3051 15.4745 45.1499 15.5C44.4599 15.5 44.46 16.1 44.38 16.87C44.3665 17.2683 44.3932 17.667 44.46 18.06L25.1599 19.06"
        stroke={color}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M12.09 30.11L4.3999 29.68L4.73999 24.39C4.80907 23.9033 4.99283 23.44 5.27625 23.0384C5.55966 22.6367 5.93461 22.3082 6.37 22.08C7.37 21.31 9.52991 20.88 11.6599 20.29C14.6175 19.3304 17.693 18.782 20.7999 18.66C20.7999 18.66 27.21 14.56 33.36 13.37"
        stroke={color}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M53.7699 29.85L25.9299 30.11"
        stroke={color}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M24.0499 26.86C24.1095 27.9657 23.8401 29.0642 23.2755 30.0168C22.7109 30.9693 21.8766 31.7331 20.878 32.2116C19.8795 32.6902 18.7614 32.8619 17.6653 32.7051C16.5691 32.5484 15.5442 32.0702 14.7197 31.331C13.8953 30.5918 13.3084 29.6248 13.0334 28.5522C12.7585 27.4796 12.8077 26.3495 13.1748 25.3048C13.5419 24.2602 14.2105 23.3478 15.0961 22.683C15.9816 22.0183 17.0443 21.6309 18.1499 21.57C19.5089 21.4744 20.8534 21.8999 21.9099 22.76"
        stroke={color}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M65.8199 26.86C65.8593 27.5947 65.7537 28.3301 65.5089 29.024C65.2641 29.7179 64.885 30.3567 64.3933 30.9041C63.9016 31.4515 63.3069 31.8967 62.6432 32.2143C61.9794 32.5319 61.2596 32.7156 60.5249 32.755C59.7902 32.7944 59.0548 32.6887 58.361 32.4439C57.6671 32.1991 57.0282 31.8201 56.4808 31.3284C55.9334 30.8367 55.4882 30.242 55.1706 29.5783C54.8531 28.9145 54.6694 28.1948 54.63 27.46C54.6168 26.9753 54.6435 26.4903 54.71 26.01C54.8559 25.2946 55.1429 24.6154 55.5541 24.0121C55.9653 23.4087 56.4925 22.8933 57.105 22.4958C57.7175 22.0984 58.4029 21.8268 59.1215 21.6971C59.84 21.5673 60.5771 21.5819 61.2899 21.74C62.1319 21.9363 62.9206 22.3152 63.6 22.85"
        stroke={color}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M7.04988 23.02C6.78988 23.28 7.04988 24.21 7.04988 24.21H10.2899C10.8899 24.21 11.3999 22.42 11.1499 22.16C9.73758 22.1518 8.33984 22.445 7.04988 23.02Z"
        stroke={color}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M69.9199 21.57H68.0399L67.2699 20.46L69 20"
        stroke={color}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
    </g>
    <defs>
      <clipPath id="clip0_816_45062">
        <rect width="67.57" height="20.14" fill="white" transform="translate(4 13)" />
      </clipPath>
    </defs>
  </svg>
);

export default SpyderDefaultIcon;
